import React from "react";
import GridToolbarNoExport from "../../../common/GridToolbarNoExport";
import AppDataGrid from "../../../common/AppDataGrid";
import { CircularProgress, Typography, Box } from "@mui/material"; // Import necessary MUI components
import useFirestore from "../../../../config/fireBaseHook"; // Correct path to useFirestore hook
import { formatDateTime } from "../../../../utils/formatDate";

// Renamed component to reflect the data source
const PlacementRequests = () => {
  // Try PlacementRequests collection first
  const { data, loading, error } = useFirestore(
    "PlacementRequests",
    "created_at",
    "desc",
  );

  // Debug logging
  console.log("PlacementRequests data:", data);
  console.log("PlacementRequests loading:", loading);
  console.log("PlacementRequests error:", error);

  // Log the first data item to see what fields are available
  if (data && data.length > 0) {
    console.log("First data item:", data[0]);
    console.log("Available fields:", Object.keys(data[0]));
  }

  // Define columns - start with basic ones that might exist
  const columns = [
    {
      field: "created_at",
      headerName: "Submitted Date",
      flex: 1,
      renderCell: (params) => formatDateTime(params.row?.created_at),
    },
    {
      field: "schoolName",
      headerName: "School",
      flex: 1,
    },
    {
      field: "fromName",
      headerName: "Contact Person",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Contact Email",
      flex: 1,
    },
    {
      field: "phone",
      headerName: "Contact Phone",
      flex: 1,
    },
    {
      field: "testingDate",
      headerName: "Requested Date",
      flex: 1,
    },
    {
      field: "testingSchedule",
      headerName: "Testing Schedule",
      flex: 1,
    },
    {
      field: "testingOptions",
      headerName: "Testing Options",
      flex: 1,
    },
    {
      field: "computerUsage",
      headerName: "Computer Usage",
      flex: 1,
    },
  ];

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <Typography color="error">Error loading data: {error}</Typography>
      </Box>
    );
  }

  // Show data count for debugging
  if (!loading) {
    console.log(`Loaded ${data?.length || 0} records from PlacementRequests`);
  }

  return (
    // Use a Box for consistent padding/styling if needed
    <Box sx={{ height: 600, width: "100%" }}>
      {" "}
      {/* Adjust height as needed */}
      <AppDataGrid
        rows={data} // Data comes directly from useFirestore
        columns={columns}
        loading={loading}
        slots={{ toolbar: GridToolbarNoExport }}
        pagination // Keep pagination enabled
        initialState={{
          // Set initial pagination state
          pagination: {
            paginationModel: { pageSize: 25, page: 0 }, // Default page size
          },
        }}
        pageSizeOptions={[10, 25, 50, 100]} // Options for page size
        disableRowSelectionOnClick // Keep this prop if needed
        getRowId={(row) => row.id} // Ensure each row has a unique ID (useFirestore provides 'id')
      />
    </Box>
  );
};

// Update the export name
export default PlacementRequests;
